import { render, staticRenderFns } from "./PersonnelRecordEditTabCertificates.vue?vue&type=template&id=2828abe6"
import script from "./PersonnelRecordEditTabCertificates.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordEditTabCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports